import { get, forEach } from 'lodash';
import { MASKED_VALUE } from '../constants';

const maskFields = (maskedObject, skipKeys = []) => {
  forEach(maskedObject, (value, key) => {
    if (typeof value === 'object') {
      maskedObject[key] = maskFields(value);
    } else if (!skipKeys.includes(key)) {
      maskedObject[key] = MASKED_VALUE;
    }
  });

  return maskedObject;
};

export const maskMemberRecord = member => {
  if (!get(member, 'isRestrictedForAdmin')) return member;

  return maskFields(member, ['id', 'isRestrictedForAdmin']);
};

export const maskConsultRecord = consult => {
  if (!get(consult, 'memberProfile.isRestrictedForAdmin')) return consult;

  return maskFields(consult, ['id', 'isRestrictedForAdmin']);
};
